export default __webpack_public_path__ + "static/media/checkbox-without-text.b5797e09.svg";